module.exports = __webpack_public_path__ + "static/media/dark-motion-raan-phasing.c59b834.mp4";